import { AntragsummerGenerated } from '../action-types/antragsummerGenerated';
import { VhvAction, VhvActions } from '../vhvActions';
import { IAppState } from '../appState';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: VhvAction<AntragsummerGenerated>,
  state: IAppState,
): string {
  switch (action.type) {
    case VhvActions.ANTRAGSNUMMER_GENERATED: {
      if (action.payload.angebotsId === state.angebotsId) {
        return action.payload.antragsnummer;
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
